/**
 * Prev/next controls for horizontally scrolling strips.
 *
 * The authenticator row is a CSS overflow scroller. On macOS and iOS the
 * scrollbar is an overlay that stays hidden until you scroll, so with a mouse
 * there is no sign the remaining logos exist — the row just looks clipped.
 *
 * Emits Dawn's OWN slider-button markup (.slider-buttons / .slider-button--prev
 * / .slider-button--next with the icon-caret svg) so the controls are visually
 * identical to the carousel arrows elsewhere on the page and inherit Dawn's
 * styling, hover and disabled states for free.
 *
 * Additive: no Dawn file is modified, and native swipe / shift-wheel scrolling
 * is untouched. Hides itself entirely when nothing overflows.
 */
(function () {
  const SELECTOR = '[id$="__graders"] .multicolumn-list';
  const CARET =
    '<span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6">' +
    '<path fill="currentColor" fill-rule="evenodd" ' +
    'd="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" ' +
    'clip-rule="evenodd"/></svg></span>';

  function build(list) {
    if (list.dataset.hofsmStripNav === 'on') return;
    const host = list.parentElement;
    if (!host) return;

    const bar = document.createElement('div');
    bar.className = 'slider-buttons hofsm-strip-buttons';

    const mk = (dir, label) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'slider-button slider-button--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML = CARET;
      return b;
    };
    const prev = mk('prev', 'Previous authenticators');
    const next = mk('next', 'Next authenticators');
    bar.appendChild(prev);
    bar.appendChild(next);
    host.appendChild(bar);

    const page = () => Math.max(160, Math.round(list.clientWidth * 0.8));
    prev.addEventListener('click', () => list.scrollBy({ left: -page(), behavior: 'smooth' }));
    next.addEventListener('click', () => list.scrollBy({ left: page(), behavior: 'smooth' }));

    const update = () => {
      const max = list.scrollWidth - list.clientWidth;
      host.classList.toggle('hofsm-strip--has-nav', max > 4);
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= max - 2;
    };

    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    window.setTimeout(update, 400);   // logos lazy-load; no width at first paint
    update();

    list.dataset.hofsmStripNav = 'on';
  }

  const boot = () => document.querySelectorAll(SELECTOR).forEach(build);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
